import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["slider"]

  handleSelectChange(event) {
    if (this.hasSliderOutlet) {
      this.sliderOutlet.currentIndexValue = event.target.selectedIndex
    }
  }
}
